import React from 'react';
import { features, coverImage } from '../data/landing';
export function ProductSection() {
  return <section className="bg-cream py-20 md:py-28" data-id="element-135" data-mp="2uvw40rp874b">
      <div className="mx-auto grid max-w-6xl gap-14 px-5 md:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-136" data-mp="2w6xxv1l34ss">
        <div className="lg:sticky lg:top-10 lg:self-start" data-id="element-137" data-mp="hlcypng2l32s">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-138" data-mp="crif0k0gso3p">
            Descubrí una nueva forma de acercarte a los Salmos
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-ink/80" data-id="element-139" data-mp="miwcyncrpfuq">
            <strong className="text-ink" data-id="element-140" data-mp="mkpiu0fk3w1o">El Poder de los Salmos</strong> es un ebook cristiano pensado para acompañarte
            en tu búsqueda de comprensión, inspiración y crecimiento espiritual.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-141" data-mp="329hj0augl5xm">
            Un recurso digital para que puedas dedicar tiempo a las Escrituras, reflexionar sobre sus enseñanzas y crear
            tus propios momentos de conexión con Dios.
          </p>
          <img src={coverImage} alt="" className="mt-10 hidden w-56 rounded-xl shadow-[0_20px_50px_-20px_rgba(43,33,24,0.45)] lg:block" data-id="element-142" data-mp="3sj1x5i3fl056" />
        </div>

        <div data-id="element-143" data-mp="5d14t6dll3we">
          <h3 className="font-serif text-3xl font-semibold text-ink" data-id="element-144" data-mp="5cizlk8yjfcc">¿Qué vas a encontrar?</h3>
          <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-145" data-mp="a40ym2rf75uo">
            {features.map(({
            icon: Icon,
            title,
            text
          }) => <li key={title} className="flex gap-5 py-7" data-id="element-146" data-mp="f4ylutraeq31">
                <Icon className="mt-1 h-6 w-6 shrink-0 text-gold" aria-hidden="true" data-id="element-147" data-mp="k0dxrg5qibwt" />
                <div data-id="element-148" data-mp="p1th93s9kad3">
                  <h4 className="font-serif text-2xl font-semibold leading-tight text-ink" data-id="element-149" data-mp="p1jo57bx9n36">{title}</h4>
                  <p className="mt-2 leading-relaxed text-muted" data-id="element-150" data-mp="t1kd3lwndgoh">{text}</p>
                </div>
              </li>)}
          </ul>
          <p className="mt-10 font-serif text-2xl italic leading-snug text-gold-dark" data-id="element-151" data-mp="2utqhcqv8vbsn">
            No se trata solamente de leer más, sino de dedicar tiempo a comprender, reflexionar y poner en práctica
            aquello que aprendés.
          </p>
        </div>
      </div>
    </section>;
}